module.exports = __webpack_public_path__ + "img/17.58362ac2.png";